import React from "react";

const AboutUs = () => {
  return (
    <section id="about" className="section">
      <div className="container">
        <p className="text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">درباره من</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">تجربه‌ای که به خروجی تبدیل می‌شود</h2>

        <div className="row">
          <div className="col-lg-8 text-center text-lg-start wow fadeInUp">
            <h2 className="text-8 fw-400 mb-3">
              سلام، من <span className="fw-700 border-bottom border-3 border-primary me-2">سینا خانجانی</span> هستم
            </h2>
            <p className="text-5">
              به‌عنوان توسعه‌دهنده و لید فنی، روی تبدیل نیازهای واقعی کسب‌وکار به نرم‌افزار قابل‌استفاده و قابل‌نگهداری کار می‌کنم.
              <br />
              تجربه‌ی من از توسعه‌ی Backend و Web تا اپلیکیشن Mobile، استقرار و نگهداری Production را پوشش می‌دهد؛ اما تمرکز همیشه روی انتخاب راه‌حل مناسب برای پروژه است، نه تعداد ابزارها.
              <br />
              در همکاری، روی ارتباط شفاف، تحویل مرحله‌ای، مستندسازی و مسئولیت‌پذیری پس از تحویل تأکید دارم.
            </p>
          </div>
          <div className="col-lg-4 mt-4 mt-lg-0 wow fadeInUp" data-wow-delay="0.2s">
            <div className="featured-box style-4">
              <div className="featured-box-icon text-25 fw-500 bg-primary rounded-circle">
                <span className="wow heartBeat" data-wow-delay="1.3s">12</span>
              </div>
              <h3 className="text-7 wow rubberBand" data-wow-delay="2s">
                سال <span className="fw-700">تجربه‌ی حرفه‌ای</span>
              </h3>
            </div>
          </div>
        </div>

        <div className="row gy-3 mt-4">
          <div className="col-6 col-lg-3 wow fadeInUp">
            <p className="text-muted fw-500 mb-0">تمرکز کاری:</p>
            <p className="text-4 text-dark fw-600 mb-0">Web، Mobile و Backend</p>
          </div>
          <div className="col-6 col-lg-3 wow fadeInUp" data-wow-delay="0.3s">
            <p className="text-muted fw-500 mb-0">نوع همکاری:</p>
            <p className="text-4 text-dark fw-600 mb-0">Freelance و Remote</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
